import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify'; // Import toast
import 'react-toastify/dist/ReactToastify.css'; // Import Toastify CSS
import '../css/login.css';

const Admin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const url = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();

  // Check if the user is already logged in
  useEffect(() => {
    const isLoggedIn = localStorage.getItem('isAdminLoggedIn');
    if (isLoggedIn) {
      window.location.href = '/admin/dashboard'; // Redirect to dashboard if already logged in
    }
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(`${url}/api/admin/login`, {
        username,
        password,
      });

      if (response.data.success) {
        // Save login state to localStorage
        localStorage.setItem('isAdminLoggedIn', true);

        toast.success('Login Successful!'); // Show success toast
        // Redirect to dashboard page after 1 second
        setTimeout(() => {
          navigate('/admin/dashboard');
        }, 1000);
      } else {
        toast.error(response.data.message);
        setError(response.data.message || 'Invalid username or password');
      }
    } catch (err) {
      toast.error('Login failed. Please check your credentials and try again.');
      setError('Invalid Admin');
      if (process.env.NODE_ENV === 'development') {
        console.error('Login error:', err);
      }
    }
  };

  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleLogin}>
        <h2>Admin Login</h2>
        {error && <p className="error-message">{error}</p>}
        <div className="form-group">
          <label htmlFor="username">Username:</label>
          <input
            type="text"
            id="username"
            placeholder="Enter username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Password:</label>
          <input
            type="password"
            id="password"
            placeholder="Enter password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <button className="login-button" type="submit">Login</button>
      </form>
    </div>
  );
};

export default Admin;
